import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewPushNotificationComponent } from './view-push-notification/view-push-notification.component';
import { ProiectePushNotificationsComponent } from './proiecte-push-notifications.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddImageComponent } from './view-push-notification/add-image/add-image.component';
import { ViewImageComponent } from './view-push-notification/view-image/view-image.component';

@NgModule({
    declarations: [
        ProiectePushNotificationsComponent,
        ViewPushNotificationComponent,
        AddImageComponent,
        ViewImageComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    exports: [ProiectePushNotificationsComponent]
})
export class ProiectePushNotificationsModule { }
